import { render, staticRenderFns } from "./Office-New-Request-Step2.vue?vue&type=template&id=cb88d11a&scoped=true&"
import script from "./Office-New-Request-Step2.vue?vue&type=script&lang=js&"
export * from "./Office-New-Request-Step2.vue?vue&type=script&lang=js&"
import style0 from "./Office-New-Request-Step2.vue?vue&type=style&index=0&id=cb88d11a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb88d11a",
  null
  
)

export default component.exports